import { render } from "./KRTabSet.vue?vue&type=template&id=a75c0bca"
import script from "./KRTabSet.vue?vue&type=script&lang=js"
export * from "./KRTabSet.vue?vue&type=script&lang=js"
script.render = render

export default script